import { getCreativeBlockVariableContract } from '../containers/ComplexDocumentDesign/complexDocumentHelper';
import {
  TABLE_OF_CONTENTS,
  CREATIVE_BLOCK,
  FILLABLE_ELEMENT,
  STANDALONE_BLOCK,
  STATIC_TABLE_BLOCK,
  DYNAMIC_TABLE_BLOCK,
} from './complexDocumentConstants';
import { autoTransform } from './helper';
import { v4 as uuidv4 } from 'uuid';

const convertToArray = input => {
  if (Array.isArray(input)) {
    return input;
  } else if (typeof input === 'object' && input !== null) {
    return [input];
  }
  return input;
};

const transformToEmailBlocks = (blocks, flowWidth, documentFontSize) => {
  const { updatedBlocks } = autoTransform(blocks, { width: 590, height: 1, fontSize: documentFontSize }, flowWidth, 1, true);
  return updatedBlocks;
};

export const docToEmail = (data, allVariables) => {
  const flows = convertToArray(data.flows);
  let emailData = [];
  let orderNumber = 0;
  flows.forEach(flow => {
    if (flow.flowName !== TABLE_OF_CONTENTS) {
      if (flow.header) {
        if(flow.header.blockType === STANDALONE_BLOCK){
          flow.header = {...flow.header, ...flow.header.blockDTOList[0]}
          flow.header.isStandalone = false;
          delete flow.header.blockDTOList;
        }
        const updatedBlocks = transformToEmailBlocks([flow.header], flow.style.width, data.style.fontSize);
        flow.header = updatedBlocks[0];
        orderNumber++;
        let headerBlock = { ...flow.header, orderNumber };
        headerBlock.contents = headerBlock.contents.filter(
          content => content.contentType !== FILLABLE_ELEMENT,
        );
        delete headerBlock.blockId;
        const { variables } = getCreativeBlockVariableContract(headerBlock.contents || [], allVariables, headerBlock?.style?.summary);
        headerBlock.variableContract = variables;
        emailData.push(headerBlock);
      }
      if (flow.blocks) {
        const processBlock = block => {
          if (block.blockType === CREATIVE_BLOCK) {
            block.contents = block.contents.filter(
              content => content.contentType !== FILLABLE_ELEMENT,
            );
            const isRepetitive = block.variableContract?.length > 0 ? block.variableContract[0].type === 'object' : false;
            const { variables } = getCreativeBlockVariableContract(block.contents || [], allVariables, block?.style?.summary, isRepetitive, isRepetitive ? block.variableContract[0].name : '');
            block.variableContract = variables;
          }
          if(block.blockType === DYNAMIC_TABLE_BLOCK){
            const { blockDTOList, style } = block;
            const { topBlock, bottomBlock } = style.tableProperties;
            const blockMapping = {};
            if (topBlock) blockMapping[topBlock] = 'topBlock';
            if (bottomBlock) blockMapping[bottomBlock] = 'bottomBlock';
            blockDTOList.forEach((block) => {
              block.isStandalone= false;
              const matchedKey = blockMapping[block.blockId];
              if (matchedKey) {
                const newUuid = uuidv4();
                block.uuid = newUuid;
                style.tableProperties[matchedKey] = newUuid;
                delete block.blockId;
              }
            });
          }
          orderNumber++;
          const blockData = { ...block, orderNumber };
          delete blockData.blockId;
          emailData.push(blockData);
        };
        const updatedBlocks = transformToEmailBlocks(flow.blocks, flow.style.width, data.style.fontSize);
        flow.block = updatedBlocks;
        flow.blocks.forEach(block => {
          if (block.blockType !== STATIC_TABLE_BLOCK) {
            if (block.blockType === STANDALONE_BLOCK) {
              const updatedBlocks = transformToEmailBlocks(block.blockDTOList, flow.style.width, data.style.fontSize);
              block.blockDTOList = updatedBlocks;
              block.blockDTOList.forEach(referencedBlock => {
                referencedBlock.isStandalone = false;
                processBlock(referencedBlock);
              });
            } else {
              processBlock(block);
            }
          }
        });
      }
      if (flow.footer) {
        if(flow.footer.blockType === STANDALONE_BLOCK){
          flow.footer = {...flow.footer, ...flow.footer.blockDTOList[0]}
          flow.footer.isStandalone = false;
          delete flow.footer.blockDTOList;
        }
        const updatedBlocks = transformToEmailBlocks([flow.footer], flow.style.width, data.style.fontSize);
        flow.footer = updatedBlocks[0];
        orderNumber++;
        let footerBlock = { ...flow.footer, orderNumber };
        footerBlock.contents = footerBlock.contents.filter(
          content => content.contentType !== FILLABLE_ELEMENT,
        );
        delete footerBlock.blockId;
        const { variables } = getCreativeBlockVariableContract(footerBlock.contents || [], allVariables, footerBlock?.style?.summary);
        footerBlock.variableContract = variables;
        emailData.push(footerBlock);
      }
    }
  });
  return emailData;
};
